<template>
  <div>
    <div v-if="profile">
      <!-- <v-card class="mx-2 mt-4" shaped outlined> -->
      <v-list-item three-line>
        <v-list-item-content>
          <div class="overline mb-2">{{ title }}</div>
          <!-- <v-btn
          x-small
          rounded
          class="mt-1"
          color="primary"
          @click="openViewStatementDialog()"
        >
          View Statement
        </v-btn> -->
          <v-list-item-title class="headline mb-1">{{
            profile.name
          }}</v-list-item-title>
          <v-list-item-subtitle>[{{ profile.id_number }}]</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-avatar tile size="80" :color="getThemeColor">
          <input
            type="file"
            id="files"
            ref="fileInput"
            style="display: none"
            accept="image/*"
            @change="getSelectedImage()"
          />
          <v-img
            size="80"
            :src="profilePic"
            style="border-radius: 50%"
            @click="openImageDialog()"
          ></v-img>
        </v-list-item-avatar>
      </v-list-item>

      <v-list two-line>
        <v-list-item>
          <v-list-item-icon>
            <v-icon :color="getThemeColor">mdi-phone</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            Contact:
            {{
              profile.phone
                ? profile.phone
                : profile.phone_number
                ? profile.phone_number
                : profile.primary_phone
                ? profile.primary_phone
                : profile.tel
                ? profile.tel
                : null
            }}</v-list-item-title
          >
        </v-list-item>

        <v-divider inset></v-divider>

        <v-list-item>
          <v-list-item-icon>
            <v-icon :color="getThemeColor">mdi-email-check</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Email: {{ profile.email }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider inset></v-divider>

        <v-list-item>
          <v-list-item-icon>
            <v-icon :color="getThemeColor">mdi-account</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>ID: {{ profile.id_number }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider inset></v-divider>

        <v-list-item>
          <v-list-item-icon>
            <v-icon :color="getThemeColor">mdi-cash</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ profile.bank }}:
              {{
                profile.account
                  ? profile.account
                  : profile.account_number
                  ? profile.account_number
                  : null
              }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider inset></v-divider>

        <v-list-item>
          <v-list-item-icon>
            <v-icon :color="getThemeColor">mdi-map-marker</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              Address:
              {{
                profile.address
                  ? profile.address
                  : profile.physical_address
                  ? profile.physical_address
                  : profile.primary_address
                  ? profile.primary_address
                  : null
              }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>

        <v-list-item>
          <v-list-item-icon>
            <v-icon :color="getThemeColor">mdi-city</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              City: {{ profile.city }},
              {{ profile.postal_code ? profile.postal_code : profile.pcode }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-card-actions></v-card-actions>
      <!-- </v-card> -->
    </div>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import imagesJs from "@/plugins/images";
import { mapGetters } from "vuex";

export default {
  props: {
    profile: {
      default: null,
    },
    title: {
      default: "Personal Profile",
    },
    imageFolder: { default: "profile_pics" },
  },
  computed: mapGetters([
    "getThemeColor",
    "getAccessToken",
    "getUserCompany",
    "getApiUrl",
  ]),
  data: () => ({
    profilePic: null,
    selectedImageName: null,

    imageExtension: null,
  }),
  watch: {
    async profile() {
      await this.setProfileImage();
    },
  },
  async mounted() {
    if (this.profile) {
      await this.setProfileImage();
    }
  },
  methods: {
    async setProfileImage() {
      this.$store.commit("setLoader", true);
      const images = await imagesJs.getImagesForGivenFolder(this.imageFolder);
      if (images.length > 0) {
        const profilePic = images.find((img) => {
          return (
            img == this.profile.id + ".jpg" ||
            img == this.profile.id + ".jpeg" ||
            img == this.profile.id + ".png"
          );
        });

        this.profilePic =
          this.getApiUrl +
          "/images/" +
          this.imageFolder +
          "/" +
          this.getUserCompany.emis +
          "/" +
          profilePic;
      }

      this.$store.commit("setLoader", false);
    },
    openImageDialog() {
      document.getElementById("files").click();
    },
    getSelectedImage() {
      const file = event.target.files[0];
      const ext = file.type.split("/")[1];
      this.imageExtension = ext;
      this.selectedImageName = this.profile.id + "." + ext;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.selectedImage = fileReader.result;
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/upload-image",
            {
              image64: this.selectedImage,
              name: this.selectedImageName,
              folder: this.imageFolder,
            },
            this.getAccessToken
          )
          .then((images) => {
            if (images.length > 0) {
              const profilePic = images.find((img) => {
                return img == this.profile.id + "." + this.imageExtension;
              });

              this.profilePic = null;
              this.$store.commit("setLoader", false);
              const img =
                this.getApiUrl +
                "/images/" +
                this.imageFolder +
                "/" +
                this.getUserCompany.emis +
                "/" +
                profilePic;

              this.profilePic = img;
            }
          });
      });
      fileReader.readAsDataURL(file);
    },
  },
};
</script>
